export enum FileExtensions {
  JPG = 'jpg',
  PNG = 'png',
  JPEG = 'jpeg',
  GIF = 'gif',
  PDF = 'pdf',
  PPTX = 'pptx',
  XLS = 'xls',
  DOCX = 'docx',
  WEBP = "webp",
  AVIF = "avif"
}

export enum ItemMoveActionType {
  Move_Up = 'Move Up',
  Move_Down = 'Move Down',
  Move_Before = 'Move Before'
}

export enum ProductStatus {
  UnLock = 'UnLock',
  Lock = 'Lock',
  Visible = 'Visible',
  Hide = 'Hide'
}

export enum ShowInSubNav {
  Show = '1',
  Hide = '0',
}

export enum SLIDE_TEMPLATES {
  WITHOUT_IMAGE = 'Without Image',
  WITH_IMAGE = 'With Image',
  ESP_PROCESS = 'ESPRequest',
  HIGHER_SLIDE = 'Higher Slide',
  Child_Slides_Place_Holder = 'ChildSlidesPlaceHolder',
  RICH_TEXT = 'RichText',
  // LEFT_ALIGNED_IMAGE = 'Left-aligned image',
  // RIGHT_ALIGNED_IMAGE = 'Right-aligned image',
  IMAGE = 'Image',
  MOBILE_IMAGE = 'Mobile image',
  BLOCKS_AND_MOBILE_IMAGE = 'Blocks and mobile image',
  BLOCKS = 'Blocks',
  CAROUSEL_GROUP = 'Carousel group',
  CARD_GROUP = 'Card group',
  TOPIC_GROUP = 'Topic group',
  SLIDE_GROUP = 'Slide Group',
  PRICE_GROUP = 'Price Group',
  HTMLPage = 'HTMLPage',
  CONTACT = 'ContactSlide',
  LEADLINE = 'LeadLine',
  GALLERY_SLIDE = 'Gallery',
  NEWS_SLIDE = 'News',
  STEPS_SLIDE = 'StepSlide',
  PRESENTATION_SLIDE = 'PresentationSlide',
  TABLE_SLIDE = 'TableSlide',
}

export enum SlideTypeEnum {
  SIMPLE_SLIDE = 'SimpleSlide',
  PRICE_SLIDE = 'PriceSlide',
  SECTION = 'Section',
  RELATED_TOPIC = 'RelatedTopic',
  RICH_TEXT = 'RichText',
  GALLERY_SLIDE = 'Gallery',
  NEWS_SLIDE = 'News',
  PRESENTATION_SLIDE = 'PresentationSlide',
  TABLE_SLIDE = 'TableSlide',

}

export enum RenderTypeEnum {
  BY_SLIDES = 'BySlides',
  DEFAULT = 'Default'
}


export enum BuiltInSlideTypes {
  TopicHeader = 'TopicHeader',
  TopicFooter = 'TopicFooter',
  Owner = 'Owner',
  RelatedTopic = 'RelatedTopic',
  Materials = 'Materials',
  Feedback = 'Feedback',
  LeadLineContact = 'LeadLineContact',
  Offers = 'Offers'
}
export enum ProductTabType {
  All = 'All',
  Mine = 'Mine',
  Other = 'Other'
}

export enum VideTypeEnum {
  UPLOAD = 'upload',
  LINK = 'link'
}


export enum ProductsDisplayMode {
  Table,
  Grid,
  List,
  Card,
  IMG
}